import { type PalletTagFacts, palletTagDeltaSum, palletTagIsConsumed, palletTagUsedAmount } from '@shared/core/policy';

/**
 * A tag row's facts, from the `quantityAdjustments` it was read with — the same used-amount test
 * the api runs on its SQL SUM. A row edited since that read is judged by the server.
 */
export const toPalletTagFacts = ({
  quantityAdjustments,
}: {
  quantityAdjustments?: readonly { delta?: number | null }[] | null;
}): PalletTagFacts => ({
  consumed: palletTagIsConsumed(palletTagUsedAmount(palletTagDeltaSum(quantityAdjustments ?? []))),
});
